/**
 * Resetear variables CSS globales en :root
 * – Optimizado para evitar forced reflow
 */
export function reset_vars_css() {
    const html = document.documentElement;

    const col1 = document.querySelector('.js-col-1');
    const col1Inner = document.querySelector('.js-col-1-inner');
    const footer = document.querySelector('.js-b-footer');

    // lectura primero
    const col1Width = col1?.offsetWidth || 0;
    const col1InnerWidth = col1Inner?.offsetWidth || 0;
    const footerHeight = footer?.offsetHeight || 0;

    // escritura después
    html.style.setProperty('--col-1', `${col1Width}px`);
    html.style.setProperty('--col-1-inner', `${col1InnerWidth}px`);
    html.style.setProperty('--footer-height', `${footerHeight}px`);
}
